import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";

export const Error404 = () => {
    const navigate = useNavigate();

    return (
        <div className="error-page">
          <h1>404</h1>
          <p className="info"><i className="fa fa-info-circle me-2"></i><FormattedMessage id={'error.noContent'}/></p>
          <p><FormattedMessage id={'error.noContent.info'}/></p>
          <button className="btn btn-primary"
            onClick={ () => { navigate("/home", { replace: true }); }}>
            <FormattedMessage id={'button.to.desktop'}/>
          </button>
      </div>

    );
};